<template>
  <div class="operation_action_panel" :class="[actionSet.setType.value == SetType.macro ? 'white_bg' : '']">
    <!-- 主设置卡片区 -->
    <div class="main_settings_card">
      <div class="config_wrapper">
        <set_type></set_type>

        <!-- 右侧内容区 -->
        <div class="settings_content" :class="{ is_empty: !hasVisibleModes }">
          <!-- 头部状态 (集成保存/重集按钮) -->
          <div class="content_header" :class="{ is_empty: !hasVisibleModes }">
            <div class="current_info" v-if="hasVisibleModes && actionSet.setType.value == SetType.routine">
              <div class="info_item">
                <span class="label">{{ $t('current_selected_key') }}</span>
                <span class="value" :class="{ is_unselected: operate.currentKey.value === -1 }">{{ currentKeyName }}</span>
              </div>
              <div class="info_arrow">→</div>
              <div class="info_item">
                <span class="label">{{ $t('mapping_action') }}</span>
                <span class="value highlight">{{ mappingActionName }}</span>
              </div>
            </div>
            <div class="senior_desc" v-else-if="hasVisibleModes">
              <div class="desc_card">
                <div class="desc_content">
                  <div class="desc_title">{{ setTexts()[actionSet.setType.value]?.title }}</div>
                  <div class="desc_text">{{ setTexts()[actionSet.setType.value]?.desc }}</div>
                </div>
              </div>
            </div>
            <div class="current_info is_locked" v-else>
              <div class="info_item">
                <span class="label">{{ $t('current_selected_key') }}</span>
                <span class="value" :class="{ is_unselected: operate.currentKey.value === -1 }">{{ currentKeyName }}</span>
              </div>
            </div>

            <div class="header_actions">
              <div v-if="isShowLayerToggle" class="header_layer_toggle_box">
                <div class="layer_toggle_hint">{{ $t('message_top_des_fn') }}</div>
                <layer_toggle class="header_layer_toggle" />
              </div>
              <template v-if="hasVisibleModes">
                <div class="mgx_action_btn" :class="{ disable: resetting, is_loading: resetStatus === 'loading', is_success: resetStatus === 'success', is_error: resetStatus === 'error' }" @click="reset">
                  <div class="btn-content-fade" :key="resetStatus">
                    <div class="icon-wrapper" v-if="resetStatus === 'idle'" style="color: var(--color-text-hint)">
                      <SvgAsset :content="actionResetSvg" />
                    </div>
                    <div class="icon-wrapper" v-else-if="resetStatus === 'loading'">
                      <SvgAsset :content="actionLoadingSvg" />
                    </div>
                    <div class="icon-wrapper" v-else-if="resetStatus === 'success'">
                      <SvgAsset :content="actionSuccessSvg" />
                    </div>
                    <div class="icon-wrapper" v-else-if="resetStatus === 'error'">
                      <SvgAsset :content="actionErrorSvg" />
                    </div>
                    <span v-if="resetStatus === 'idle'" style="color: var(--color-text-hint)">{{ $t('magnet_reset_keys') }}</span>
                  </div>
                </div>
                <div class="mgx_action_btn primary" :class="{ disable: saving, is_loading: saveStatus === 'loading', is_success: saveStatus === 'success', is_error: saveStatus === 'error' }" @click="save">
                  <div class="btn-content-fade" :key="saveStatus">
                    <div class="icon-wrapper" v-if="saveStatus === 'idle'">
                      <SvgAsset :content="actionSaveSvg" />
                    </div>
                    <div class="icon-wrapper" v-else-if="saveStatus === 'loading'">
                      <SvgAsset :content="actionLoadingSvg" />
                    </div>
                    <div class="icon-wrapper" v-else-if="saveStatus === 'success'">
                      <SvgAsset :content="actionSuccessSvg" />
                    </div>
                    <div class="icon-wrapper" v-else-if="saveStatus === 'error'">
                      <SvgAsset :content="actionErrorSvg" />
                    </div>
                    <span v-if="saveStatus === 'idle'">{{ $t('save') }}</span>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <template v-if="hasVisibleModes">
            <!-- 具体设置项 -->
            <div class="specific_settings_area" :class="[actionSet.setType.value == SetType.macro ? 'is_macro' : '']">
              <template v-if="actionSet.setType.value != SetType.macro">
                <!-- 选键区域 -->
                <div class="keys_selection_box" :class="{ is_senior: actionSet.setType.value != SetType.routine }">
                  <template v-if="actionSet.setType.value != SetType.routine">
                    <div class="senior_content_container">
                      <action_mt v-if="actionSet.setType.value == SetType.mt" :tab="baseTab" :keys="selectedKeys" />
                      <action_dks v-if="actionSet.setType.value == SetType.dks" :tab="baseTab" :keys="selectedKeys" />
                      <action_tgl v-if="actionSet.setType.value == SetType.tgl" :type="actionSet.setType.value" :tab="baseTab" :keys="selectedKeys" />
                      <action_kme ref="kmeRef" v-if="actionSet.setType.value == SetType.kme" :type="actionSet.setType.value" :tab="baseTab" :keys="selectedKeys" />
                      <action_rs v-if="actionSet.setType.value == SetType.rs" :type="actionSet.setType.value" :tab="baseTab" :keys="selectedKeys" />
                      <action_end v-if="actionSet.setType.value == SetType.end" :type="actionSet.setType.value" :tab="baseTab" :keys="selectedKeys" />
                      <action_mpt v-if="actionSet.setType.value == SetType.mpt" :type="actionSet.setType.value" :tab="baseTab" :keys="selectedKeys" />
                    </div>
                  </template>
                  <template v-else>
                    <action_fire v-if="actionSet.fireShow.value" />

                    <div class="grid_tabs">
                      <div class="grid_tab" :class="{ active: actionSet.actionType.value == ActionType.base && baseTab == BaseTabs.base }" @click="changeGridTab(ActionType.base, BaseTabs.base)">
                        {{ $t('action_set_base_chat') }}
                      </div>
                      <div class="grid_tab" :class="{ active: actionSet.actionType.value == ActionType.base && baseTab == BaseTabs.extend }" @click="changeGridTab(ActionType.base, BaseTabs.extend)">
                        {{ $t('action_set_special_chat') }}
                      </div>
                      <div v-if="isSupportCompose" class="grid_tab" :class="{ active: actionSet.actionType.value == ActionType.base && baseTab == BaseTabs.compose }" @click="changeGridTab(ActionType.base, BaseTabs.compose)">
                        {{ $t('action_set_combination_key') }}
                      </div>
                      <div v-if="isSupportMouse" class="grid_tab" :class="{ active: actionSet.actionType.value == ActionType.base && baseTab == BaseTabs.mouse }" @click="changeGridTab(ActionType.base, BaseTabs.mouse)">
                        {{ $t('action_set_mouse_key') }}
                      </div>
                      <div v-if="isSupportMultiMedia" class="grid_tab" :class="{ active: actionSet.actionType.value == ActionType.multiMedia }" @click="changeGridTab(ActionType.multiMedia)">
                        {{ $t('action_set_multimedia') }}
                      </div>
                    </div>

                    <div class="grid_content_wrapper">
                      <div class="grid_content scrollbar_thumb">
                        <base_keys v-if="actionSet.actionType.value == ActionType.base" :tab="baseTab" :set-type="actionSet.setType.value" />
                        <multimedia v-if="actionSet.actionType.value == ActionType.multiMedia" />
                      </div>
                    </div>
                  </template>
                </div>
              </template>

              <!-- 宏编辑 -->
              <macro_edit v-else @back="back" />
            </div>
          </template>
          <template v-else>
            <div class="empty_content_guide">
              <div class="guide_content_card">
                <div class="guide_badge">{{ operate.fnCheck.value ? $t('layer_switch_fn') : $t('current_selected_key') }}</div>
                <div class="guide_title">
                  {{ currentKeyName }}
                </div>
                <div class="guide_text">
                  {{ actionMessage || $t('unset') }}
                </div>
              </div>
            </div>
          </template>
        </div>
        <!-- settings_content end -->
      </div>
      <!-- config_wrapper end -->
    </div>
    <!-- main_settings_card end -->
  </div>
</template>

<script lang="ts" setup>
import i18n from '@/languages/i18n'
import Set_type from './set_type.vue'
import { actionMessage, setTexts, hasVisibleModes, checkSupport } from './action_config'
import { actionSet } from '@/service/driver/action_set'
import { ActionType, BaseTabs, SetType } from '@/service/driver/action_types'
import base_keys from './base_keys.vue'
import multimedia from './multimedia.vue'
import macro_edit from './macro_edit.vue'
import Layer_toggle from './layer_toggle.vue'
import { operate } from '@/service/driver/operate'
import action_mt from './action_mt.vue'
import action_dks from './action_dks.vue'
import action_tgl from './action_tgl.vue'
import action_kme from './action_kme.vue'
import action_rs from './action_rs.vue'
import action_end from './action_end.vue'
import action_mpt from './action_mpt.vue'

import action_fire, { fireCount, fireInterval } from './action_fire.vue'
import { setData } from '@/service/driver/data'
import { computed, onMounted, ref, watch } from 'vue'
import { DialogType, enableDialog } from '../cdialog/dialog'
import SvgAsset from '../common/SvgAsset.vue'
import actionErrorSvg from '@/assets/inline-svg/action-error.svg?raw'
import actionLoadingSvg from '@/assets/inline-svg/action-loading.svg?raw'
import actionResetSvg from '@/assets/inline-svg/action-reset.svg?raw'
import actionSaveSvg from '@/assets/inline-svg/action-save.svg?raw'
import actionSuccessSvg from '@/assets/inline-svg/action-success.svg?raw'
import { toRefs } from 'vue'
import { SetMagnetSenior } from '@/service/response'
import { normalizeKeyCode } from '@/tool/utility'
import { MapKeyType } from '@/service/driver/data'
import { DeviceType, MagnetSeniorType } from '@libs/types/enum'
import Select, { hoverKK } from '../device/select.vue'
import { kks, VK } from '@/define/define'
import { getCurrentDeviceMagnetKKs } from '@/profiles/selector'
import { appConfig } from '@/model/config'
import { DeviceCapability } from '@/service/device_capability'
import { kbVKTexture, mouseVKs, mediaVKS } from '@/define/vkcode'
import { speciaBehiver, specialCheckCurrent } from '@/define/limit'
import firmware from '@/upgrade/firmware'
import { isSupportKME } from './action_config'
import { delay } from '@libs/utils/tools'
import { getCurrentDevice } from '@/profiles/selector'

const { t } = i18n.global

const kmeRef = ref<InstanceType<typeof action_kme> | null>(null)

const isSupportRS = ref(false)

const isSupportCompose = computed(() => checkSupport.compose())
const isSupportMouse = computed(() => checkSupport.mouse())
const isSupportMultiMedia = computed(() => checkSupport.multiMedia())
const isSupportFire = computed(() => checkSupport.fire())
const isShowLayerToggle = computed(() => !specialCheckCurrent(speciaBehiver.NotSupportFnKey))

onMounted(async () => {
  showHoverSet()
  isSupportKME.value = await DeviceCapability.isSupportKME()
  isSupportRS.value = (await firmware.versionIs20241125a()) || (specialCheckCurrent(speciaBehiver.DevicesOfJingtai_V2) && (await firmware.jingtaiV2_isSupportRS())) || specialCheckCurrent(speciaBehiver.DevicesOfHuoChaiRen)
})

const currentKeyName = computed(() => {
  if (operate.currentKey.value === -1) return t('unselected')
  const vk = kks.value[operate.currentKey.value]
  console.log('currentKeyName', vk)
  if (getCurrentDevice.value.deviceType === DeviceType.mouse) {
    return t(mouseVKs[vk] || `Mouse ${vk}`)
  }
  return t(kbVKTexture[vk] || `Key ${vk}`)
})

const mappingActionName = computed(() => {
  const type = actionSet.setType.value
  const { t } = i18n.global

  if (type === SetType.macro) {
    return actionSet.macroValue.Records && actionSet.macroValue.Records.length > 0 ? `${t('macro')}` : t('unset')
  }

  // 1. 火力键判定
  if (type === SetType.routine && actionSet.fireShow.value) {
    return isSupportFire.value ? t('fire_key') : t('unset')
  }

  // 2. 多媒体判定
  if (type === SetType.routine && actionSet.actionType.value === ActionType.multiMedia) {
    const vk = actionSet.multimediaValue.value
    return isSupportMultiMedia.value && vk > 0 ? t(mediaVKS[vk]) || `Media ${vk}` : t('unset')
  }

  // 3. 高级模式与常规模式统一处理按键显示
  let keys: VK[] = []
  if (type === SetType.routine) {
    keys = selectedKeys.value
  } else {
    // 高级模式从 magnetValue 中获取第一个有效按键组
    const magnetKeys = actionSet.magnetValue.Keys
    if (magnetKeys && magnetKeys.length > 0) {
      keys = magnetKeys[0].KeyCode || []
    }
  }

  const activeKeys = keys.filter((k) => k > 0)
  if (activeKeys.length === 0) {
    // 如果是常规改键且火力键打开，上面已经处理了。这里处理未选中任何按键的情况。
    return t('unset')
  }

  // 4. 兼容性校验：辅助键/组合键
  const hasModifier = activeKeys.some((k) => k > 0 && activeKeys.indexOf(k) < 2 && activeKeys.length > 1) // 简单判定是否有修饰键
  if ((keys[0] > 0 || keys[1] > 0) && !isSupportCompose.value) {
    return t('unset')
  }

  // 5. 兼容性校验：鼠标键
  const mainKey = keys[2] || 0
  if (mouseVKs[mainKey] && !isSupportMouse.value) {
    return t('unset')
  }

  // 6. 格式化输出
  if (activeKeys.length > 1) {
    return activeKeys.map((k) => kbVKTexture[k] || k).join(' + ')
  }

  if (mouseVKs[mainKey]) return t(mouseVKs[mainKey])
  return kbVKTexture[mainKey] || t('unset')
})

let saving = ref(false)
let resetting = ref(false)
let saveStatus = ref('idle') // idle, loading, success, error
let resetStatus = ref('idle') // idle, loading, success, error

const { baseTab, selectedKeys } = toRefs(actionSet.baseKeys)

watch(baseTab, (val) => {
  if (val == BaseTabs.mouse && !isSupportMouse.value) {
    changeGridTab(ActionType.base, BaseTabs.base)
  }
})

watch(
  () => actionSet.actionType.value,
  (val) => {
    if (val == ActionType.multiMedia && !isSupportMultiMedia.value) {
      changeGridTab(ActionType.base, BaseTabs.base)
    }
  },
)

watch(
  () => isSupportCompose.value,
  (val) => {
    if (!val && baseTab.value == BaseTabs.compose) {
      changeGridTab(ActionType.base, BaseTabs.base)
    }
  },
)

watch(
  [() => baseTab.value, () => [...selectedKeys.value]],
  ([newTab, newKeys]) => {
    if (newTab == BaseTabs.compose) {
      saving.value = (newKeys[0] == 0 && newKeys[1] == 0) || newKeys[2] == 0
    } else {
      saving.value = false
    }

    const normalized = normalizeKeyCode(newKeys, newTab)
    if (JSON.stringify(normalized) !== JSON.stringify(newKeys)) {
      selectedKeys.value = normalized
    }
  },
  { immediate: true },
)

const back = () => {
  console.log('back')
  operate.currentKey.value = -1
  actionSet.resetData()
}

const changeGridTab = (type: ActionType, tab?: BaseTabs) => {
  if (actionSet.actionType.value !== type) {
    actionSet.changeActionType(type)
  }
  if (tab !== undefined) {
    actionSet.changeBaseTab(tab)
  }
}

const save = async () => {
  if (saving.value || saveStatus.value !== 'idle') {
    return
  }
  if (operate.currentKey.value < 0) {
    submitKesyNotice(t('Please_select_the_button_you_want_to_save'))
    return
  }
  saving.value = true
  saveStatus.value = 'loading'

  const handleSuccess = () => {
    saving.value = false
    saveStatus.value = 'success'
    setTimeout(() => {
      saveStatus.value = 'idle'
    }, 1000)
  }

  const handleError = () => {
    saving.value = false
    saveStatus.value = 'error'
    setTimeout(() => {
      saveStatus.value = 'idle'
    }, 1000)
  }

  if (actionSet.setType.value == SetType.routine) {
    if (actionSet.fireShow.value) {
      saveFire().then(handleSuccess).catch(handleError)
    } else {
      let promise: Promise<any> | undefined
      if (actionSet.actionType.value == ActionType.base) {
        promise = saveBase()
      } else if (actionSet.actionType.value == ActionType.multiMedia) {
        promise = saveMedia()
      }

      if (promise && typeof promise.then === 'function') {
        promise.then(handleSuccess).catch(handleError)
      } else {
        handleSuccess()
      }
    }
  } else if (actionSet.setType.value == SetType.macro) {
    const res = actionSet.saveMacro()
    if (res && typeof res.then === 'function') {
      res.then(handleSuccess).catch(handleError)
    } else {
      handleSuccess()
    }
  } else {
    const data = checkMagnetSenior(actionSet.magnetValue)
    if (data instanceof Error) {
      submitKesyNotice(data.message)
      saveStatus.value = 'error'
      setTimeout(() => {
        saveStatus.value = 'idle'
      }, 1000)
      return
    }

    if (data.KeyType == MagnetSeniorType.SeniorKeyTypeMPT) {
      data.Keys = data.Keys.sort((a, b) => a.Travel - b.Travel)
    }

    if (data.KeyType == MagnetSeniorType.SeniorKeyTypeKME) {
      kmeRef.value?.closeDelayTime()
    }

    setData.saveMagnetSenior(operate.currentKey.value, data).then(handleSuccess).catch(handleError)
  }
}

const reset = () => {
  if (operate.currentKey.value < 0) {
    submitKesyNotice(t('Please_select_the_button_you_want_to_save'))
    return
  }
  if (!resetting.value && resetStatus.value === 'idle') {
    resetting.value = true
    resetStatus.value = 'loading'
    actionSet
      .resetBaseValue()
      ?.then(() => {
        resetting.value = false
        resetStatus.value = 'success'
        setTimeout(() => {
          resetStatus.value = 'idle'
        }, 1000)
      })
      .catch(() => {
        resetting.value = false
        resetStatus.value = 'error'
        setTimeout(() => {
          resetStatus.value = 'idle'
        }, 1000)
      })
  }
}

const saveBase = () => {
  let KeyModifier: number[] = []
  if (baseTab.value == BaseTabs.compose) {
    KeyModifier = [selectedKeys.value[0], selectedKeys.value[1]].filter((item) => item > 0)
  }

  if (selectedKeys.value[2] == 0) {
    submitKesyNotice(t('Please_select_the_button_you_want_to_save'))
    return
  }
  const type = baseTab.value == BaseTabs.mouse ? MapKeyType.Mouse : MapKeyType.base
  return setData.setKeyMap(operate.currentKey.value, selectedKeys.value[2], KeyModifier, type).then(() => {
    saving.value = false
  })
}

const saveFire = () => {
  let KeyFire: number[] = []
  if (actionSet.fireShow.value) {
    KeyFire = [fireCount.value, fireInterval.value]
  }
  return setData.setKeyFire(operate.currentKey.value, KeyFire).then(() => {
    actionSet.saveFireKeyAndClearOthers()
    saving.value = false
  })
}

const saveMedia = () => {
  if (actionSet.multimediaValue.value == 0) {
    submitKesyNotice(t('Please_select_the_button_you_want_to_save'))
    return
  }
  return setData.setKeyMedia(operate.currentKey.value, actionSet.multimediaValue.value)?.then(() => {
    saving.value = false
    // actionSet.actionType.value = ActionType.base;
    // baseTab.value = BaseTabs.base
  })
}

const checkMagnetSenior = (data: SetMagnetSenior): SetMagnetSenior | Error => {
  const resultData = JSON.parse(JSON.stringify(data)) as SetMagnetSenior
  resultData.Keys.forEach((item) => {
    item.KeyCode = item.KeyCode.filter((key) => key > 0)
  })
  if (resultData.KeyType == MagnetSeniorType.SeniorKeyTypeMT && resultData.Keys[0].KeyCode.length == 0 && resultData.Keys[1].KeyCode.length == 0) {
    return Error(t('Please_select_the_button_you_want_to_save'))
  }
  if (resultData.KeyType == MagnetSeniorType.SeniorKeyTypeTGL && resultData.Keys[0].KeyCode.length == 0) {
    return Error(t('Please_select_the_button_you_want_to_save'))
  }
  if (resultData.KeyType == MagnetSeniorType.SeniorKeyTypeKME && resultData.Keys[0].KeyCode.length == 0) {
    return Error(t('Please_select_the_button_you_want_to_save'))
  }
  if (resultData.KeyType == MagnetSeniorType.SeniorKeyTypeKME && resultData.Keys[0].KeyCode[0] == getCurrentDeviceMagnetKKs.value[operate.currentKey.value]) {
    return Error(t('Please_select_othen_key_for_kme'))
  }
  if (resultData.KeyType == MagnetSeniorType.SeniorKeyTypeEND && resultData.Keys[0].KeyCode.length == 0) {
    return Error(t('Please_select_the_button_you_want_to_save'))
  }
  if (resultData.KeyType == MagnetSeniorType.SeniorKeyTypeRS && resultData.Keys[0].KeyCode.length == 0) {
    return Error(t('Please_select_the_button_you_want_to_save'))
  }
  if (resultData.KeyType == MagnetSeniorType.SeniorKeyTypeMPT) {
    let isErr = true
    resultData.Keys.forEach((item) => {
      if (item.KeyCode.filter((e) => e > 0).length > 0) {
        isErr = false
      }
    })
    if (isErr) {
      return Error(t('Please_select_the_button_you_want_to_save'))
    }
  }
  const { keyCodeCount, functionCount } = countKeyCodesAndFunctions(resultData)
  if (resultData.KeyType === MagnetSeniorType.SeniorKeyTypeDKS) {
    if (keyCodeCount === 0) {
      return Error(t('Please_select_the_button_you_want_to_save'))
    }
    if (functionCount === 0) {
      return Error(t('Please_select_the_travel_you_want_to_save'))
    }
  }

  return resultData
}

const countKeyCodesAndFunctions = (data: SetMagnetSenior): { keyCodeCount: number; functionCount: number } => {
  let keyCodeCount = 0
  let functionCount = 0

  for (const item of data.Keys) {
    const keyCodeLength = item.KeyCode.filter((key) => key > 0).length
    const functionLength = item.KeyFunction.filter((key) => key > 0).length

    if (keyCodeLength === 0 && functionLength === 0) {
      continue
    }

    keyCodeCount = keyCodeLength
    functionCount = functionLength

    if (keyCodeLength > 0 && functionLength > 0) {
      break
    }
  }
  return { keyCodeCount, functionCount }
}

const submitKesyNotice = (message: string) => {
  enableDialog(message, DialogType.alert, false)
  saving.value = false
}

onMounted(() => {
  if (actionSet.setType.value === undefined) {
    actionSet.setType.value = SetType.routine
  }
  showHoverSet()
})

watch(operate.currentKey, () => {
  showHoverSet()
})
// InstanceType组件模板引用标注类型
const hoverRef = ref<InstanceType<typeof Select> | null>(null)
const setElement = ref<HTMLElement | null>(null)
const showHoverSet = () => {
  const vk = kks.value[operate.currentKey.value]
  setElement.value = null
  setTimeout(() => {
    setElement.value = document.getElementById(`${vk}`)
    hoverKK.value = operate.currentKey.value
    hoverRef.value?.updateHover()
  }, 1)
}
watch(setData.getData(), () => {
  showHoverSet()
}),
  { deep: true }
</script>

<style lang="less" scoped>
.operation_action_panel {
  --operation-action-card-height: clamp(410px, 425px, 440px);
  --spacing-panel-y: 4px; /* 紧凑模式 */
  --spacing-panel-gap: 8px; /* 紧凑模式 */
  --spacing-panel-x: 16px; /* 紧凑模式 */
  width: 100%;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  transition: var(--transition-base);
  align-items: stretch;

  &.white_bg {
    background: transparent;
  }

  /* 主设置卡片区 */
  .main_settings_card {
    position: relative;
    width: 100%;
    height: var(--operation-action-card-height);
    min-height: var(--operation-action-card-height);
    border-radius: var(--radius-l);
    display: flex;
    flex-direction: column; /* 纵向排列：Banner 在上，内容在下 */
    flex: 0 0 auto;
    border: 1px solid rgba(255, 255, 255, 0.1);
    align-self: center; /* 居中 */
    transition: transform 0.4s cubic-bezier(0.23, 1, 0.32, 1);
    outline: none;
    background: transparent;
    overflow: hidden; /* 裁剪 Banner 顶部圆角 */

    /* 核心修复：使用伪元素实现毛玻璃背景，解决 position: fixed 子元素被 trapped 的问题 */
    &::before {
      content: '';
      position: absolute;
      inset: 0;
      background: var(--glass-panel-bg);
      backdrop-filter: var(--glass-panel-blur);
      border-radius: inherit;
      z-index: -1;
      pointer-events: none;
    }

    .config_wrapper {
      flex: 1;
      display: flex; /* 内部恢复横向布局：侧边栏 | 内容区 */
      width: 100%;
      min-height: 0;
    }
  }

  /* 消息提示框 - (已弃用) */
  .message {
    display: none;
  }

  @keyframes messageFadeIn {
    from {
      opacity: 0;
      transform: translate(-50%, -20px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translate(-50%, 0) scale(1);
    }
  }

  /* 侧边栏 (轻盈呼吸感) */
  .settings_sidebar {
    width: 210px;
    flex-shrink: 0;
    background: rgba(255, 235, 225, 0.35); /* 柔和暖色背景，契合截图 */
    backdrop-filter: var(--glass-panel-blur);
    border-right: 1px solid rgba(255, 255, 255, 0.5);
    padding: 12px 14px;
    display: flex;
    flex-direction: column;
    z-index: 2;
    overflow-y: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari and Opera */
    }

    .sidebar_item {
      position: relative;
      cursor: pointer;
      transition: var(--transition-base);
      border-radius: var(--radius-m);
      margin-bottom: 2px;
      padding: 0 4px;

      .sidebar_item_inner {
        position: relative;
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 12px 16px;
        border-radius: var(--radius-m);
        transition: var(--transition-base);
      }

      .icon_box {
        width: 38px;
        height: 38px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: var(--radius-m);
        background: rgba(0, 0, 0, 0.03);
        transition: var(--transition-base);

        .sidebar_icon {
          width: 20px;
          height: 20px;
          object-fit: contain;
          opacity: 0.6;
          transition: var(--transition-base);
        }
      }

      .sidebar_label {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .main_text {
          font-size: 14px;
          font-weight: 700;
          color: var(--color-dark);
          line-height: 1.2;
          transition: var(--transition-base);
          opacity: 0.8;
        }
        .sub_text {
          font-size: 9px;
          color: var(--color-text-hint);
          text-transform: uppercase;
          margin-top: 2px;
          letter-spacing: 0.8px;
          transition: var(--transition-base);
          font-weight: 800;
          opacity: 0.4;
        }
      }

      /* 状态交互 */
      &:hover:not(.active) {
        .sidebar_item_inner {
          background: rgba(255, 255, 255, 0.5);
        }
        .main_text {
          opacity: 1;
        }
        .icon_box {
          background: rgba(255, 255, 255, 0.8);
        }
      }

      &.active {
        .sidebar_item_inner {
          background: #ffffff;
          box-shadow: 0 12px 30px rgba(0, 0, 0, 0.06);
          /* 胶囊状左侧指示器 */
          &::before {
            content: '';
            position: absolute;
            left: -4px;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 24px;
            background: var(--color-brand-2);
            border-radius: 0 100px 100px 0;
            box-shadow: 2px 0 8px rgba(255, 107, 0, 0.3);
          }
        }

        .icon_box {
          background: rgba(255, 107, 0, 0.06);
          border: 1px solid rgba(255, 107, 0, 0.1);

          .sidebar_icon {
            opacity: 1;
            filter: none; /* 保持原色或者彩色 */
          }
        }

        .main_text {
          color: var(--color-dark);
          opacity: 1;
        }

        .sub_text {
          color: var(--color-brand-2);
          opacity: 0.7;
          overflow: hidden; /* 裁剪 Banner 顶部圆角 */

          /* 空态引导 */
          .empty_content_guide {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            background: rgba(255, 255, 255, 0.4);

            .guide_box {
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 16px;
              opacity: 0.3;

              .guide_icon {
                width: 48px;
                height: 48px;
                color: var(--color-dark);
              }

              .guide_text {
                font-size: 14px;
                font-weight: 500;
                color: var(--color-dark);
              }
            }
          }
        }
      }
    }
  }

  /* 右侧内容 */
  .settings_content {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0;
    background: #fff;
    min-width: 0; /* 防止内容过多（如宏列表）导致撑开并挤压侧边栏 */
    min-height: 0;
    height: 100%;
    border-radius: 0px var(--radius-l) var(--radius-l) 0px;

    &.is_empty {
      justify-content: center;
      align-items: stretch;
    }

    .empty_content_guide {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 24px;
      animation: feedbackFadeIn 0.4s var(--transition-base);

      .guide_content_card {
        width: min(100%, 520px);
        padding: 32px;
        border-radius: var(--radius-l);
        background: var(--glass-surface-bg);
        backdrop-filter: var(--glass-surface-blur);
        border: 1px solid rgba(255, 255, 255, 0.7);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        gap: 12px;
      }

      .guide_badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-height: 28px;
        padding: 0 14px;
        border-radius: var(--radius-pill);
        background: rgba(var(--color-brand-2-rgb), 0.08);
        color: var(--brand-color-pure);
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0.4px;
      }

      .guide_title {
        font-size: 24px;
        line-height: 1.2;
        font-weight: 700;
        color: var(--color-dark);
      }

      .guide_text {
        font-size: 14px;
        line-height: 1.7;
        color: var(--color-text-hint);
      }
    }

    &.conflict_locked {
      justify-content: center;
      align-items: center;
      background: rgba(255, 255, 255, 0.4);
      backdrop-filter: blur(10px);

      .locked_box {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        padding: 40px;
        max-width: 400px;
        animation: feedbackFadeIn 0.5s var(--transition-base);

        .locked_icon_wrapper {
          width: 64px;
          height: 64px;
          background: rgba(var(--color-brand-2-rgb), 0.1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 24px;

          .locked_icon {
            width: 32px;
            height: 32px;
          }
        }

        .locked_text {
          font-size: 18px;
          font-weight: 700;
          color: var(--color-dark);
          margin-bottom: 12px;
        }

        .locked_sub {
          font-size: 13px;
          color: var(--color-text-hint);
          line-height: 1.6;
        }
      }
    }

    .content_header {
      padding: 10px var(--spacing-panel-x);
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: rgba(255, 255, 255, 0.2);
      border-bottom: 1px solid var(--border-color);
      border-radius: 0px var(--radius-l) 0px 0px;

      &.is_empty {
        .current_info.is_locked {
          .value {
            color: var(--color-dark);
          }
        }
      }

      .current_info {
        display: flex;
        align-items: center;
        gap: 20px;

        .info_item {
          display: flex;
          flex-direction: column;
          gap: 2px;
          min-width: 80px;

          .label {
            font-size: 10px;
            color: var(--color-text-hint);
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }
          .value {
            font-size: 14px;
            font-weight: 700;
            color: var(--color-dark);

            &.is_unselected {
              color: var(--color-text-hint);
            }

            &.highlight {
              color: var(--brand-color-pure);
              text-shadow: 0 0 10px rgba(var(--color-brand-1-rgb), 0.1);
            }
          }
        }

        .info_arrow {
          font-size: 14px;
          color: var(--color-text-hint);
          opacity: 0.3;
          font-weight: 400;
          margin-top: 12px;
        }
      }

      .senior_desc {
        flex: 1;
        display: flex;
        align-items: center;
        animation: descFadeIn 0.4s var(--transition-base);

        .desc_card {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          padding: 12px 16px;
          background: rgba(var(--color-brand-2-rgb), 0.03);
          border-radius: var(--radius-s);
          border-left: 3px solid var(--brand-color-pure);
          max-width: 600px;

          .desc_icon {
            width: 18px;
            height: 18px;
            color: var(--brand-color-pure);
            margin-top: 2px;
            flex-shrink: 0;
            svg {
              width: 100%;
              height: 100%;
            }
          }

          .desc_content {
            display: flex;
            flex-direction: column;
            gap: 2px;

            .desc_title {
              font-size: 13px;
              font-weight: 700;
              color: var(--color-dark);
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              -webkit-box-orient: vertical;
            }

            .desc_text {
              font-size: 12px;
              color: var(--color-text-hint);
              line-height: 1.4;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
        }
      }

      @keyframes descFadeIn {
        from {
          opacity: 0;
          transform: translateX(-10px);
        }
        to {
          opacity: 1;
          transform: translateX(0);
        }
      }

      .header_actions {
        display: flex;
        align-items: center;
        gap: 12px;

        .header_layer_toggle_box {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 6px 12px;
          border-radius: var(--radius-m);
          background: rgba(0, 0, 0, 0.025);
          flex-shrink: 0;
          margin-right: 4px;

          .layer_toggle_hint {
            font-size: 12px;
            line-height: 1.2;
            color: var(--color-text-hint);
            white-space: nowrap;
          }

          .header_layer_toggle {
            flex-shrink: 0;
          }
        }

        /* 使用全局 .mgx_action_btn 样式 */
        .mgx_action_btn {
          font-weight: 700;
          box-shadow: none !important;

          &:hover,
          &:active {
            transform: none !important;
            box-shadow: none !important;
          }

          &.primary {
            box-shadow: none !important;

            &:hover,
            &:active {
              box-shadow: none !important;
            }
          }
        }
      }
    }

    .specific_settings_area {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      overflow: hidden;

      &.is_macro {
        overflow: hidden; /* 宏编辑器必须溢出隐藏以提供内部滚动 */
        min-height: 0;
      }

      .keys_selection_box {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
        padding: var(--spacing-panel-y) var(--spacing-panel-x);
        gap: var(--spacing-panel-gap);
        overflow: hidden;

        &.is_senior {
          justify-content: center;
          align-items: center;
          gap: 20px;
        }

        .senior_content_container {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .grid_tabs {
          flex-shrink: 0;
          display: flex;
          gap: 20px;
          padding: 0 4px;
          background: transparent;
          /* border-bottom: 1px solid var(--border-color); */
          width: 100%;
          margin-bottom: 6px;
          margin-top: 6px;

          .grid_tab {
            position: relative;
            padding: 8px 12px;
            cursor: pointer;
            font-size: 13px;
            font-weight: 500;
            transition: var(--transition-base);
            color: var(--color-text-hint);

            &::after {
              content: '';
              position: absolute;
              bottom: -1px;
              left: 50%;
              transform: translateX(-50%) scaleX(0);
              width: 70%;
              height: 3px;
              background: var(--brand-color-pure);
              border-radius: 100px;
              transition: var(--transition-base);
            }

            &:hover {
              color: var(--color-dark);
            }

            &.active {
              color: var(--brand-color-pure);
              font-weight: 600;

              &::after {
                transform: translateX(-50%) scaleX(1);
              }
            }
          }
        }

        .grid_content_wrapper {
          flex: 1;
          min-height: 0;
          background: var(--color-gray-1);
          border-radius: var(--radius-l);
          overflow: hidden;
          display: flex;
          flex-direction: column;

          .grid_content {
            flex: 1;
            min-height: 0;
            overflow-y: auto;
            padding-right: 6px;

            &::-webkit-scrollbar {
              width: 4px;
            }
            &::-webkit-scrollbar-track {
              background: transparent;
            }
            &::-webkit-scrollbar-thumb {
              background: rgba(0, 0, 0, 0.05);
              border-radius: var(--radius-pill);

              &:hover {
                background: rgba(0, 0, 0, 0.1);
              }
            }
          }
        }
      }
    }
  }
}
</style>
